import { render, staticRenderFns } from "./TailwindCssSelectors.vue?vue&type=template&id=413b552a&"
import script from "./TailwindCssSelectors.vue?vue&type=script&lang=js&"
export * from "./TailwindCssSelectors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports